import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { float64_type, list_type, union_type, class_type, record_type, option_type, int32_type, string_type, bool_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { map, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { toFail, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { toShortDateString } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { TerminationState$reflection, InvoiceePaymentState$reflection, PaymentMethod$reflection, BillingInterval$reflection, InvoiceeType$reflection, VatMode$reflection, Distribution$reflection, InvoiceeState$reflection } from "../../DomainTypes.js";
import { UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { list, string, object } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { utcDecoder } from "../../CustomEncoders.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";

export class ContractType extends Record {
    constructor(Active, ContractTypeCode, Display, NContracts, PriceListCode, ProductNr, NetworkContractNr) {
        super();
        this.Active = Active;
        this.ContractTypeCode = ContractTypeCode;
        this.Display = Display;
        this.NContracts = (NContracts | 0);
        this.PriceListCode = PriceListCode;
        this.ProductNr = (ProductNr | 0);
        this.NetworkContractNr = NetworkContractNr;
    }
}

export function ContractType$reflection() {
    return record_type("Containers.Invoicee.Common.ContractType", [], ContractType, () => [["Active", bool_type], ["ContractTypeCode", string_type], ["Display", string_type], ["NContracts", int32_type], ["PriceListCode", option_type(string_type)], ["ProductNr", int32_type], ["NetworkContractNr", option_type(int32_type)]]);
}

export class SubscriptionListPhoneNumber extends Record {
    constructor(ActiveFrom, ActiveTo, ContractNr, IsActive, NetworkContractNr, NumberFrom, NumberTo) {
        super();
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.ContractNr = (ContractNr | 0);
        this.IsActive = IsActive;
        this.NetworkContractNr = (NetworkContractNr | 0);
        this.NumberFrom = NumberFrom;
        this.NumberTo = NumberTo;
    }
}

export function SubscriptionListPhoneNumber$reflection() {
    return record_type("Containers.Invoicee.Common.SubscriptionListPhoneNumber", [], SubscriptionListPhoneNumber, () => [["ActiveFrom", option_type(class_type("System.DateTimeOffset"))], ["ActiveTo", option_type(class_type("System.DateTimeOffset"))], ["ContractNr", int32_type], ["IsActive", bool_type], ["NetworkContractNr", int32_type], ["NumberFrom", string_type], ["NumberTo", string_type]]);
}

export class InvoiceeFileType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Agreement", "GeneralFile"];
    }
}

export function InvoiceeFileType$reflection() {
    return union_type("Containers.Invoicee.Common.InvoiceeFileType", [], InvoiceeFileType, () => [[], []]);
}

export function InvoiceeFileTypeModule_toInt(ift) {
    if (ift.tag === 1) {
        return 3;
    }
    else {
        return 0;
    }
}

export class PendingNumberForContract extends Record {
    constructor(Number$, ContractNr) {
        super();
        this.Number = Number$;
        this.ContractNr = (ContractNr | 0);
    }
}

export function PendingNumberForContract$reflection() {
    return record_type("Containers.Invoicee.Common.PendingNumberForContract", [], PendingNumberForContract, () => [["Number", string_type], ["ContractNr", int32_type]]);
}

export class NumbersForContract extends Record {
    constructor(ActiveNumbers, PendingNumbers) {
        super();
        this.ActiveNumbers = ActiveNumbers;
        this.PendingNumbers = PendingNumbers;
    }
}

export function NumbersForContract$reflection() {
    return record_type("Containers.Invoicee.Common.NumbersForContract", [], NumbersForContract, () => [["ActiveNumbers", list_type(SubscriptionListPhoneNumber$reflection())], ["PendingNumbers", list_type(PendingNumberForContract$reflection())]]);
}

export class TerminateFeeOptionJson extends Record {
    constructor(SetBoundMonthsToZero, SetCancellationPeriodToZero) {
        super();
        this.SetBoundMonthsToZero = SetBoundMonthsToZero;
        this.SetCancellationPeriodToZero = SetCancellationPeriodToZero;
    }
}

export function TerminateFeeOptionJson$reflection() {
    return record_type("Containers.Invoicee.Common.TerminateFeeOptionJson", [], TerminateFeeOptionJson, () => [["SetBoundMonthsToZero", bool_type], ["SetCancellationPeriodToZero", bool_type]]);
}

export class TerminateFeeDTO extends Record {
    constructor(CancelledDate, Options) {
        super();
        this.CancelledDate = CancelledDate;
        this.Options = Options;
    }
}

export function TerminateFeeDTO$reflection() {
    return record_type("Containers.Invoicee.Common.TerminateFeeDTO", [], TerminateFeeDTO, () => [["CancelledDate", string_type], ["Options", TerminateFeeOptionJson$reflection()]]);
}

export class ContractTypeChange extends Record {
    constructor(StartDate, EndDate, ContractTypeCode, Display, CreatedDate) {
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.ContractTypeCode = ContractTypeCode;
        this.Display = Display;
        this.CreatedDate = CreatedDate;
    }
}

export function ContractTypeChange$reflection() {
    return record_type("Containers.Invoicee.Common.ContractTypeChange", [], ContractTypeChange, () => [["StartDate", class_type("System.DateTimeOffset")], ["EndDate", option_type(class_type("System.DateTimeOffset"))], ["ContractTypeCode", string_type], ["Display", string_type], ["CreatedDate", class_type("System.DateTimeOffset")]]);
}

export class Contract extends Record {
    constructor(CancelledDate, ClientCrossRef, ContractNumber, ContractTypeCode, CreatedBy, CreatedTime, EndUser, EndUserCategory, EndUserOrganizationnr, InvoiceeNumber, LatestActiveNumber, MortgageAmount, MortgageAmountApproved, NoNextInvoice, ObjectNumber, SpecifiedInvoice, StartDate, UpdatedTime, IsPayedInvoicesMandatory, PayedInvoices, IsCreditCheckMandatory, CreditCheck, IsValid, MonthlyValueInRange, IsPhysicalContractsMandatory, PhysicalContracts, AgeInRange, CurrentState) {
        super();
        this.CancelledDate = CancelledDate;
        this.ClientCrossRef = ClientCrossRef;
        this.ContractNumber = (ContractNumber | 0);
        this.ContractTypeCode = ContractTypeCode;
        this.CreatedBy = CreatedBy;
        this.CreatedTime = CreatedTime;
        this.EndUser = EndUser;
        this.EndUserCategory = EndUserCategory;
        this.EndUserOrganizationnr = EndUserOrganizationnr;
        this.InvoiceeNumber = InvoiceeNumber;
        this.LatestActiveNumber = LatestActiveNumber;
        this.MortgageAmount = MortgageAmount;
        this.MortgageAmountApproved = MortgageAmountApproved;
        this.NoNextInvoice = NoNextInvoice;
        this.ObjectNumber = ObjectNumber;
        this.SpecifiedInvoice = SpecifiedInvoice;
        this.StartDate = StartDate;
        this.UpdatedTime = UpdatedTime;
        this.IsPayedInvoicesMandatory = IsPayedInvoicesMandatory;
        this.PayedInvoices = PayedInvoices;
        this.IsCreditCheckMandatory = IsCreditCheckMandatory;
        this.CreditCheck = CreditCheck;
        this.IsValid = IsValid;
        this.MonthlyValueInRange = MonthlyValueInRange;
        this.IsPhysicalContractsMandatory = IsPhysicalContractsMandatory;
        this.PhysicalContracts = PhysicalContracts;
        this.AgeInRange = AgeInRange;
        this.CurrentState = CurrentState;
    }
}

export function Contract$reflection() {
    return record_type("Containers.Invoicee.Common.Contract", [], Contract, () => [["CancelledDate", option_type(class_type("System.DateTime"))], ["ClientCrossRef", option_type(string_type)], ["ContractNumber", int32_type], ["ContractTypeCode", string_type], ["CreatedBy", string_type], ["CreatedTime", class_type("System.DateTime")], ["EndUser", option_type(string_type)], ["EndUserCategory", option_type(string_type)], ["EndUserOrganizationnr", string_type], ["InvoiceeNumber", class_type("System.Int64")], ["LatestActiveNumber", option_type(string_type)], ["MortgageAmount", option_type(float64_type)], ["MortgageAmountApproved", option_type(float64_type)], ["NoNextInvoice", bool_type], ["ObjectNumber", option_type(int32_type)], ["SpecifiedInvoice", bool_type], ["StartDate", option_type(class_type("System.DateTime"))], ["UpdatedTime", class_type("System.DateTime")], ["IsPayedInvoicesMandatory", bool_type], ["PayedInvoices", bool_type], ["IsCreditCheckMandatory", bool_type], ["CreditCheck", bool_type], ["IsValid", bool_type], ["MonthlyValueInRange", bool_type], ["IsPhysicalContractsMandatory", bool_type], ["PhysicalContracts", bool_type], ["AgeInRange", bool_type], ["CurrentState", string_type]]);
}

export class Address extends Record {
    constructor(PostalAddress, PostalAttention, PostalCity, PostalCode, PostalCountryCode) {
        super();
        this.PostalAddress = PostalAddress;
        this.PostalAttention = PostalAttention;
        this.PostalCity = PostalCity;
        this.PostalCode = PostalCode;
        this.PostalCountryCode = PostalCountryCode;
    }
}

export function Address$reflection() {
    return record_type("Containers.Invoicee.Common.Address", [], Address, () => [["PostalAddress", string_type], ["PostalAttention", string_type], ["PostalCity", string_type], ["PostalCode", string_type], ["PostalCountryCode", string_type]]);
}

export class InvoiceSettings extends Record {
    constructor(CustomPaymentSlip, DirectDebit, DirectDebitDistribute, PeppolId) {
        super();
        this.CustomPaymentSlip = CustomPaymentSlip;
        this.DirectDebit = DirectDebit;
        this.DirectDebitDistribute = DirectDebitDistribute;
        this.PeppolId = PeppolId;
    }
}

export function InvoiceSettings$reflection() {
    return record_type("Containers.Invoicee.Common.InvoiceSettings", [], InvoiceSettings, () => [["CustomPaymentSlip", bool_type], ["DirectDebit", bool_type], ["DirectDebitDistribute", bool_type], ["PeppolId", string_type]]);
}

export class CreditScore extends Record {
    constructor(Approved, Scoring, Date$) {
        super();
        this.Approved = Approved;
        this.Scoring = Scoring;
        this.Date = Date$;
    }
}

export function CreditScore$reflection() {
    return record_type("Containers.Invoicee.Common.CreditScore", [], CreditScore, () => [["Approved", bool_type], ["Scoring", option_type(string_type)], ["Date", class_type("System.DateTime")]]);
}

export function CreditScore_FormatToString(getTranslation, countryCode, creditScore) {
    const approved = creditScore.Approved ? getTranslation("CustomerContract.Invoicee.Approved") : getTranslation("CustomerContract.Invoicee.NotApproved");
    const scoring = defaultArg(map((score) => toText(printf("%s "))(score), creditScore.Scoring), "");
    if (countryCode === "FIN") {
        const arg_2 = toShortDateString(creditScore.Date);
        return toText(printf("%s (%s)"))(approved)(arg_2);
    }
    else {
        const arg_5 = toShortDateString(creditScore.Date);
        return toText(printf("%s - %s(%s)"))(approved)(scoring)(arg_5);
    }
}

export class InvoiceeDetails extends Record {
    constructor(Address, BilledTo, ClientContactReference, ClientCrossRef, ContactPhoneNumber, ContractNumbers, CountryCode, Created, CurrentState, CustomerGroupCode, DistributionCode, HasInvoiceFee, Email, EmailAddressInvoice, EInvoiceIdentifier, CurrencyCode, ExclVat, InvoiceSettings, InvoiceType, InvoiceeBatchId, InvoiceeContactReference, InvoiceeNr, ManualDistributionChannel, MonthlyBillingInterval, MortgageBlocked, Name, NoNextInvoice, OrganizationNr, OurReference, PaymentMethod, PaymentState, PaymentTermsFixedDay, PaymentTermsNetDays, Updated, TerminationState) {
        super();
        this.Address = Address;
        this.BilledTo = BilledTo;
        this.ClientContactReference = ClientContactReference;
        this.ClientCrossRef = ClientCrossRef;
        this.ContactPhoneNumber = ContactPhoneNumber;
        this.ContractNumbers = ContractNumbers;
        this.CountryCode = CountryCode;
        this.Created = Created;
        this.CurrentState = CurrentState;
        this.CustomerGroupCode = CustomerGroupCode;
        this.DistributionCode = DistributionCode;
        this.HasInvoiceFee = HasInvoiceFee;
        this.Email = Email;
        this.EmailAddressInvoice = EmailAddressInvoice;
        this.EInvoiceIdentifier = EInvoiceIdentifier;
        this.CurrencyCode = CurrencyCode;
        this.ExclVat = ExclVat;
        this.InvoiceSettings = InvoiceSettings;
        this.InvoiceType = InvoiceType;
        this.InvoiceeBatchId = (InvoiceeBatchId | 0);
        this.InvoiceeContactReference = InvoiceeContactReference;
        this.InvoiceeNr = InvoiceeNr;
        this.ManualDistributionChannel = ManualDistributionChannel;
        this.MonthlyBillingInterval = MonthlyBillingInterval;
        this.MortgageBlocked = MortgageBlocked;
        this.Name = Name;
        this.NoNextInvoice = NoNextInvoice;
        this.OrganizationNr = OrganizationNr;
        this.OurReference = OurReference;
        this.PaymentMethod = PaymentMethod;
        this.PaymentState = PaymentState;
        this.PaymentTermsFixedDay = PaymentTermsFixedDay;
        this.PaymentTermsNetDays = PaymentTermsNetDays;
        this.Updated = Updated;
        this.TerminationState = TerminationState;
    }
}

export function InvoiceeDetails$reflection() {
    return record_type("Containers.Invoicee.Common.InvoiceeDetails", [], InvoiceeDetails, () => [["Address", option_type(Address$reflection())], ["BilledTo", option_type(class_type("System.DateOnly"))], ["ClientContactReference", string_type], ["ClientCrossRef", option_type(string_type)], ["ContactPhoneNumber", string_type], ["ContractNumbers", list_type(int32_type)], ["CountryCode", string_type], ["Created", class_type("System.DateTime")], ["CurrentState", InvoiceeState$reflection()], ["CustomerGroupCode", option_type(int32_type)], ["DistributionCode", Distribution$reflection()], ["HasInvoiceFee", bool_type], ["Email", string_type], ["EmailAddressInvoice", option_type(string_type)], ["EInvoiceIdentifier", option_type(string_type)], ["CurrencyCode", option_type(string_type)], ["ExclVat", VatMode$reflection()], ["InvoiceSettings", InvoiceSettings$reflection()], ["InvoiceType", InvoiceeType$reflection()], ["InvoiceeBatchId", int32_type], ["InvoiceeContactReference", string_type], ["InvoiceeNr", class_type("System.Int64")], ["ManualDistributionChannel", bool_type], ["MonthlyBillingInterval", BillingInterval$reflection()], ["MortgageBlocked", bool_type], ["Name", string_type], ["NoNextInvoice", bool_type], ["OrganizationNr", string_type], ["OurReference", option_type(string_type)], ["PaymentMethod", PaymentMethod$reflection()], ["PaymentState", InvoiceePaymentState$reflection()], ["PaymentTermsFixedDay", option_type(int32_type)], ["PaymentTermsNetDays", option_type(int32_type)], ["Updated", class_type("System.DateTime")], ["TerminationState", TerminationState$reflection()]]);
}

export class ContractTypePriceDTO extends Record {
    constructor(ContractTypePriceId, Name) {
        super();
        this.ContractTypePriceId = (ContractTypePriceId | 0);
        this.Name = Name;
    }
}

export function ContractTypePriceDTO$reflection() {
    return record_type("Containers.Invoicee.Common.ContractTypePriceDTO", [], ContractTypePriceDTO, () => [["ContractTypePriceId", int32_type], ["Name", string_type]]);
}

export class TransferHistory extends Record {
    constructor(FromContractNr, FromAtUtc, ToContractNr, ToAtUtc) {
        super();
        this.FromContractNr = FromContractNr;
        this.FromAtUtc = FromAtUtc;
        this.ToContractNr = ToContractNr;
        this.ToAtUtc = ToAtUtc;
    }
}

export function TransferHistory$reflection() {
    return record_type("Containers.Invoicee.Common.TransferHistory", [], TransferHistory, () => [["FromContractNr", option_type(int32_type)], ["FromAtUtc", option_type(UTC$reflection())], ["ToContractNr", option_type(int32_type)], ["ToAtUtc", option_type(UTC$reflection())]]);
}

export class BlockType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["UnBlock", "SoftBlock", "HardBlock"];
    }
}

export function BlockType$reflection() {
    return union_type("Containers.Invoicee.Common.BlockType", [], BlockType, () => [[], [], []]);
}

export function BlockType_OfString_Z721C83C5(str) {
    const matchValue = str.toLocaleUpperCase();
    switch (matchValue) {
        case "UNBLOCK": {
            return new BlockType(0);
        }
        case "SOFTBLOCK": {
            return new BlockType(1);
        }
        case "HARDBLOCK": {
            return new BlockType(2);
        }
        default: {
            return toFail(printf("Cannot parse %s into BlockType."))(str);
        }
    }
}

export function BlockType_ToString_1C243297(bt) {
    switch (bt.tag) {
        case 1: {
            return "SOFTBLOCK";
        }
        case 2: {
            return "HARDBLOCK";
        }
        default: {
            return "UNBLOCK";
        }
    }
}

export class InvoiceeBlock extends Record {
    constructor(BlockType, AtUtc, Note, Error$) {
        super();
        this.BlockType = BlockType;
        this.AtUtc = AtUtc;
        this.Note = Note;
        this.Error = Error$;
    }
}

export function InvoiceeBlock$reflection() {
    return record_type("Containers.Invoicee.Common.InvoiceeBlock", [], InvoiceeBlock, () => [["BlockType", BlockType$reflection()], ["AtUtc", UTC$reflection()], ["Note", string_type], ["Error", string_type]]);
}

export function InvoiceeBlock_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3;
        return new InvoiceeBlock(BlockType_OfString_Z721C83C5((objectArg = get$.Required, objectArg.Field("BlockType", string))), (objectArg_1 = get$.Required, objectArg_1.Field("AtUtc", utcDecoder)), (objectArg_2 = get$.Required, objectArg_2.Field("Note", string)), (objectArg_3 = get$.Required, objectArg_3.Field("Error", string)));
    }, path_4, v));
}

export function InvoiceeBlock_get_ListDecoder() {
    const decoder = InvoiceeBlock_get_Decoder();
    return (path) => ((value) => list(uncurry(2, decoder), path, value));
}

export class InvoiceeTerminationStateHistory extends Record {
    constructor(ArchivedAt, CreatedAt, State) {
        super();
        this.ArchivedAt = ArchivedAt;
        this.CreatedAt = CreatedAt;
        this.State = State;
    }
}

export function InvoiceeTerminationStateHistory$reflection() {
    return record_type("Containers.Invoicee.Common.InvoiceeTerminationStateHistory", [], InvoiceeTerminationStateHistory, () => [["ArchivedAt", UTC$reflection()], ["CreatedAt", UTC$reflection()], ["State", string_type]]);
}

export class InvoiceeTerminationState extends Record {
    constructor(ClientNumber, CreatedAt, CurrentState, History, InvoiceeNumber) {
        super();
        this.ClientNumber = (ClientNumber | 0);
        this.CreatedAt = CreatedAt;
        this.CurrentState = CurrentState;
        this.History = History;
        this.InvoiceeNumber = (InvoiceeNumber | 0);
    }
}

export function InvoiceeTerminationState$reflection() {
    return record_type("Containers.Invoicee.Common.InvoiceeTerminationState", [], InvoiceeTerminationState, () => [["ClientNumber", int32_type], ["CreatedAt", option_type(UTC$reflection())], ["CurrentState", string_type], ["History", list_type(InvoiceeTerminationStateHistory$reflection())], ["InvoiceeNumber", int32_type]]);
}

